// import React, { memo, useEffect, useState } from 'react'
// import CustomDataGrid from '../../../../../components/dataTable/customDataGrid'
// import { Autocomplete, Button, Checkbox, Chip, FormControlLabel, Grid, IconButton, Switch, TextField } from '@mui/material'
// import { Delete, Print, RestaurantRounded } from '@mui/icons-material'
// import axios from 'axios'
// import { useDispatch } from 'react-redux'
// import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
// import _ from 'lodash'
// import QRCode from 'react-qr-code'

// const BarcodeTable = () => {
//   const dispatch = useDispatch()
//     const outletID = localStorage.getItem("outlet_id")
//   const [supplier, setSupplier] = useState([]);
//   const[cust, setCust] = useState({ id: 0, fullname: 'All' })
//   const[status, setStatus] = useState()
//   const[salesStatus, setSalesStatus] = useState()
//   const [missedDamageStatus, setMissedDamageStatus] = useState();

//   // const [supCust , setSubCust] = useState({ id: 0, fullname: 'All' })
//     const pageOption = [10,25,50,100]
//     const [page, setPage] = useState(0)
//     const [rowsPerPage, setRowsPerPage] = useState(100);
//     // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
//     const [pageCount, setPageCount] = useState(0);
//     const [search, setSearch] = useState('')
//     const [data, setData] = useState([])
//     const [ switchStatus , setSwitchStatus] = useState(false)
//     const [switchData , setSwitchData] = useState([])
//     const [checkedRows, setCheckedRows] = useState([]);
//     const [printers, setPrinters] = useState([]);
//     const [selectedPrinter, setSelectedPrinter] = useState('barcode');
//     const [filters, setFilters] = useState({
//   discount_min: '',
//   discount_max: '',
// });
// console.log(filters,"filters123343");

// const handleFilterChange = (e) => {
//   const { name, value } = e.target;
//   setFilters(prev => ({ ...prev, [name]: value }));
// };

//     useEffect(() => {
//       // Define the WebSocket settings
//       window.JSPM.JSPrintManager.auto_reconnect = true;
//       window.JSPM.JSPrintManager.start();
//       window.JSPM.JSPrintManager.WS.onStatusChanged = () => {
//         if (jspmWSStatus()) {
//           // Get client installed printers
//           window.JSPM.JSPrintManager.getPrinters().then(myPrinters => {
//             // Append the 'Barcode' option to the list of printers
//             const updatedPrinters = [...myPrinters, 'barcode'];
//             // Update the printer list state
//             setPrinters(updatedPrinters);
//             console.log(updatedPrinters, "updatedPrinters");
//           });
//         }
//       };
      
//       const jspmWSStatus = () => {
//         if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Open) {
//           return true;
//         } else if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Closed) {
//           alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
//           return false;
//         } else if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Blocked) {
//           alert('JSPM has blocked this website!');
//           return false;
//         }
//       };
    
//       // Cleanup function
//       return () => {
//         // Cleanup actions if needed
//       };
//     }, []);
//     // useEffect(() => {
//     //   window.JSPM.JSPrintManager.auto_reconnect = true;
//     //   window.JSPM.JSPrintManager.start();
//     //   window.JSPM.JSPrintManager.WS.onStatusChanged = () => {
//     //     if (jspmWSStatus()) {
//     //       window.JSPM.JSPrintManager.getPrinters().then(myPrinters => {
//     //         setPrinters(myPrinters);
//     //         console.log(myPrinters)
//     //       });
//     //     }
//     //   };
//     //   const jspmWSStatus = () => {
//     //     if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Open) {
//     //       return true;
//     //     } else if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Closed) {
//     //       alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
//     //       return false;
//     //     } else if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Blocked) {
//     //       alert('JSPM has blocked this website!');
//     //       return false;
//     //     }
//     //   };
//     //   return () => {
//     //   };
//     // }, []);
//     const handlePrinterChange = event => {
//       setSelectedPrinter(event.target.value);
//     };
//     const handleTestPrint = () => {
//       if (checkedRows.length % 4 === 0 && selectedPrinter) {
//         const content = generateXPML();
    
//         console.log(content);
//         // Convert the content string to a buffer
//         const encoder = new TextEncoder();
//         const buffer = encoder.encode(content);
//         // Create a ClientPrintJob for test print
//         const cpj = new window.JSPM.ClientPrintJob();
//         // Set the selected printer for test print
//         cpj.clientPrinter = new window.JSPM.InstalledPrinter(selectedPrinter);
//         // Set the content to be printed (e.g., a test page)
//         // const content = 'This is a test print from React app.';
       
     
//         cpj.binaryPrinterCommands = new Uint8Array(buffer);
         
//         cpj.sendToClient();
        
        
//         console.log('Print job sent successfully!');
//       }
//       else if(!selectedPrinter){
//         dispatch(setSnackbar(true , "error" , "Please select Printer Type"))
//       }
//       else{
//         dispatch(setSnackbar(true , "error" , "Series of 4 barcode selection is allowed at a time"))
//       }
//     };
//     const generateXPML = ( ) => {
//       let xpmlMarkup = '';
//       const Data = checkedRows.map(item => ({
//       barcode: item.barcode,
//       itemCode: item.sub_title,
//       MRP: parseFloat(item.mrp.replace("Rs.", "").trim()),
//       subTitle:item.sub_title,
//       // .replace("Rs.", "").trim()
//       itemName: item.sub_title
//       }));
//     let j=0;
//       for (let i = 0; i < Data.length; i++) {
//         const dr = Data[i];
//         // Check if it's the first item in the group of four
//         if (i % 4 === 3) {
//           xpmlMarkup += `
//             TEXT 770,113,"3",180,1,1,"GIRLUSH"
//             TEXT 790,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
//             TEXT 788,61,"0",180,8,8,"Rs:"
//             TEXT 750,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
//             TEXT 790,32,"0",180,7,9,"${dr.barcode || ''}"
//             QRCODE 670,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"
//           `;
//         }
      
//         // Check if it's the second item in the group of four
//         if (i % 4 === 2) {
//           xpmlMarkup += `
//             TEXT 571,113,"3",180,1,1,"GIRLUSH"
//             TEXT 591,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
//             TEXT 589,61,"0",180,8,8,"Rs:"
//             TEXT 551,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
//             TEXT 591,32,"0",180,7,9,"${dr.barcode || ''}"
//             QRCODE 471,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"
//           `;
//         }
      
//         // Check if it's the third item in the group of four
//         if (i % 4 === 1) {
//           xpmlMarkup += `
//             TEXT 371,113,"3",180,1,1,"GIRLUSH"
//             TEXT 391,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
//             TEXT 389,61,"0",180,8,8,"Rs:"
//             TEXT 351,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
//             TEXT 391,32,"0",180,7,9,"${dr.barcode || ''}"
//             QRCODE 271,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"
//           `;
//         }
      
//         // Check if it's the last item in the group of four
//         if (i % 4 === 0) {
//           xpmlMarkup += `<xpml>
//           <page quantity='0' pitch='15.0 mm'></xpml>SIZE 101.6 mm, 15 mm
//           DIRECTION 0,0
//           REFERENCE 0,0
//           OFFSET 0 mm
//           SET PEEL OFF
//           SET CUTTER OFF
//           SET PARTIAL_CUTTER OFF
//           <xpml></page></xpml><xpml><page quantity='1' pitch='15.0 mm'></xpml>SET TEAR ON
//           CLS`;
  
//           xpmlMarkup += `
//             TEXT 172,113,"3",180,1,1,"GIRLUSH"
//             TEXT 192,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
//             TEXT 190,61,"0",180,8,8,"Rs:"
//             TEXT 152,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
//             TEXT 192,32,"0",180,7,9,"${dr.barcode || ''}"
//             TEXT 48,102,"0",180,6,6,"${dr.purchaseCode || ''}"
//             QRCODE 72,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"  
//           `; 
//         }
//   j++;
//   if (j % 4 === 0) {
//         xpmlMarkup += `
//         PRINT 1,1
//         <xpml></page></xpml><xpml><end/></xpml>
//       `; 
      
//   }      
//       }
//       return xpmlMarkup;
//     };
//     const onStatusChange = (e) => {
//       console.log(e)
//       const switchDatas = {
//         barcode : e.barcode,
//         is_active:e.status === true ? false : true
//       }
//       console.log(switchData)
//       axios.post(`/v1/barcode/deactivate` , switchDatas)
//       .then((res) => {console.log(res);setSwitchStatus(!switchStatus)})
//       .catch((err) => {console.log(err);dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))})
//     }
//     const handleCheckboxChange = (row) => {
//       console.log(row)
//       const selectedIndex = checkedRows.findIndex(selectedRow => selectedRow.id === row.id);
//       let newChecked = [];
  
//       if (selectedIndex === -1) {
//           newChecked = newChecked.concat(checkedRows, row);
//       } else if (selectedIndex === 0) {
//           newChecked = newChecked.concat(checkedRows.slice(1));
//       } else if (selectedIndex === checkedRows.length - 1) {
//           newChecked = newChecked.concat(checkedRows.slice(0, -1));
//       } else if (selectedIndex > 0) {
//           newChecked = newChecked.concat(
//               checkedRows.slice(0, selectedIndex),
//               checkedRows.slice(selectedIndex + 1)
//           );
//       }
  
//       setCheckedRows(newChecked);
//   };
//   const handlePrint = (e,selectedRow) => {
//     // console.log(e)
//     if (checkedRows.length > 0) {
//       // Print the selected rows
//       console.log(checkedRows);
//   } else if (selectedRow) {
//       // Print the row associated with the clicked print button
//       console.log([selectedRow]);
//   } else {
//       // No rows selected and no row associated with the clicked print button
//       console.log("No row selected.");
//       dispatch(setSnackbar(true ,'error' , "No row selected"))
//   }
//   }
//   function getSupplierData() {
//     axios
//       .get(`/v1/outlet/list/1`)
//       .then((res) => {
//         console.log(res.data)
//         setSupplier(res.data);
//       })
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   }
//     console.log(checkedRows)
//     const handleDeleteRow = (rowIndex) => {
//       const updatedData = [...data];
//       const deletedRow = updatedData.splice(rowIndex, 1)[0]; // Remove the row from the data
//       setData(updatedData);
//       deleteTempData(deletedRow.barcode); // Call deleteTempData function to delete from the backend
//     };
  
//     const deleteTempData = (barcode) => {
//       axios.post(`/v1/barcode/list/del`, { barcode: [barcode] }) // Send barcode as an array
//         .then(res => {
//           console.log(res);
//           dispatch(setSnackbar(true, 'success', 'Barcode deleted successfully!'));
//           // Optionally refresh the data or update the state here
//         })
//         .catch(err => {
//           console.error(err.response ? err.response.data : err);
//           dispatch(setSnackbar(true, 'error', err.response?.data?.errors[0]?.message || 'Error deleting row'));
//         });
//     };
    
//     const columns =[
//         // {
//         //     field: "sno",
//         //     headerName: "S.no",
//         //     flex: 1,
//         //     minWidth: 70,
//         //     maxWidth: 100,
//         //     headerAlign: "center",
//         //     align: "center",
//         //     sortable: false,
//         //   },
//         {
//           field: "sno",
//           headerName: "S.no",
//           headerAlign: "center",
//           align: "center",
//           sortable: false,
//           renderCell: (params) => (
//             <FormControlLabel control={
//             <Checkbox  disabled={params.row.status === false} 
//             onChange={() => handleCheckboxChange(params.row)}
//              />}
//               // checked={checkedRows.some(selectedRow => selectedRow.id === params.row.id)}
//                label={params.row.sno} />
//           )
//       },
//       {
//         field: "code",
//         headerName: "Code",
//         flex: 1,
//         headerAlign: "center",
//         align: "center",
//         sortable: false,
//       },
//       {
//         field: "fullname",
//         headerName: "Outlet Name",
//         flex: 1,
//         headerAlign: "center",
//         align: "center",
//         sortable: false,
//       },
//           {
//             field: "product",
//             headerName: "Product Name",
//             flex: 1,
//             headerAlign: "center",
//             align: "center",
//             sortable: false,
//           },
//           {
//             field: "barcode",
//             headerName: "Barcode",
//             minWidth:170,
//             headerAlign: "center",
//             align: "center",
//             sortable: false,
//           },
//           {
//             field: "barCodeImg",
//             headerName: "QR Code",
//             disableExport: true ,
//             flex: 1,
//             headerAlign: "center",
//             align: "center",
//             sortable: false,
//             renderCell: (params) => {
//               return(
//                 <QRCode value={params.row.barcode} style={{height:20, width:20,}}/>
//               )
//             }
//           },
//           {
//             field: "mainCatName",
//             headerName: "Main Category Name",
//             minWidth:170,
//             headerAlign: "center",
//             align: "center",
//             sortable: false,
//           },
//           {
//             field: "subCatName",
//             headerName: "Sub Category Name",
//             minWidth:170,
//             headerAlign: "center",
//             align: "center",
//             sortable: false,
//           },
//           {
//             field: "specialDisc",
//             headerName: "Special Discount",
//             minWidth:170,
//             headerAlign: "center",
//             align: "center",
//             sortable: false,
//           },
//           {
//             field: "active",
//             headerName: "Status",
//             flex: 1,
//             headerAlign: "center",
//             align: "center",
//             disableExport: true ,
//             sortable: false,
//             disableColumnMenu: true,
//             renderCell: (params) => 
//               {
//                 console.log(params.row.isVerified)
//                 return(
//                 <div className="">
//                    <Chip size='small' color={params.row.isVerified === 1 ? 'success' : params.row.isVerified === 2 ? 'error' : "primary"} label={params.row.isVerified === 1  ? 'Verified' :params.row.isVerified === 2 ? 'Missed' : "Generated"}/>
//                 </div>
//                 )
                
//               }
//           },
//           {
//             field: "is_missed",
//             headerName: "Missed Status",
//             headerAlign: "center",
//             align: "center",
//             sortable: false,
//            disableExport: true,
//            renderCell: (params) => {
//            return params.row.is_missed
//            ? <Chip size="small" color="warning" label="Missed" />
//            : <Chip size="small" color="default" label="-" />;
//        }
//     },
//   {
//           field: "is_damage",
//          headerName: "Damage Status",
//          headerAlign: "center",
//          align: "center",
//         sortable: false,
//         disableExport: true,
//          renderCell: (params) => {
//         return params.row.is_damage === 1
//        ? <Chip size="small" color="error" label="Damaged" />
//       : <Chip size="small" color="default" label="-" />;
//     }
//   },

//           {
//             field: "status",
//             disableExport: true ,
//             headerName: "Status",
//             headerAlign: "center",
//             align: "center",
//             sortable: false,
//           renderCell: (params) => (
//             <Switch
//             onChange={() => onStatusChange(params.row)}
//            checked={params.row.status}
//           />
//           )
//           },
//           {
//             field: "action",
//             headerName: "Action",
//             headerAlign: "center",
//             disableExport: true ,
//             align: "center",
//             sortable: false,
//           renderCell: (params) => (
//             <>
//             <Button onClick={() => handlePrint(params.row)} disabled={params.row.status===false}><Print color={params.row.status ? '' : 'disabled'}/></Button>
//            {/* <IconButton onClick={() => handleDeleteRow(params.rowIndex)}><Delete sx={{color:'red', fontSize:18}}/></IconButton> */}
//            <IconButton
//   onClick={() => {
//     const rowIndex = data.findIndex(item => item.barcode === params.row.barcode);
//     handleDeleteRow(rowIndex);
//   }}
// >
//   <Delete sx={{ color: 'red', fontSize: 18 }} />
// </IconButton>

//             </>
//           )
//           },
//     ]
//     const rows = _.map(data,(val,idx)=>({
//       id:val.barcode,
//       sno: idx + 1,
//       product : val.item_name || "-",
//       barcode: val.barcode,
//       status:val.is_active,
//       mrp:val.mrp,
//       sub_title:val.sub_title,
//       title:val.title,
//       code:val.code || "-",
//       fullname:val.fullname || "-",
//       isVerified:val.is_verified,
//       mainCatName: val.main_category_name,
//       subCatName:val.sub_category_name,
//       specialDisc:val.special_discount,
//       is_missed: val.is_missed,
//       is_damage: val.is_damage,
//     }))
//     const props = {
//         rows : rows,
//         columns : columns,
//         search : search,
//         setSearch : setSearch,
//         page: page,
//         setPage : setPage,
//         rowsPerPage : rowsPerPage,
//         setRowsPerPage : setRowsPerPage,
//         pageCount : pageCount,
//         pageOption : pageOption,
//         // checkboxSelection:true,
//       }
//       useEffect(() => {
//         getSupplierData();
//       }, []);
//       console.log(cust.id)
//   // useEffect(()=>{
//   //   const url = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${cust!==null ? cust.id : 0}`
//   //   const searchUrl = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${cust.id}/${search}`
//   //   const satusUrl = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${status.id}`
//   //   // v1/barcode/lists/1/10/1/0/?warhouse_status=1&is_sold_status=true
//   //   axios.get(search === '' ? url : searchUrl)
//   //   .then(res=>{
//   //     console.log(res.data)
//   //     setData(res.data.data)
//   //     setPageCount(res.data.meta.pagination.total)
//   //     setSwitchData(res.data.data)
//   //   })
//   //   .catch(err=>{
//   //     console.log(err)
//   //     dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
//   //     setData([])
//   //   })
//   // },[search,page, rowsPerPage,switchStatus,cust])
//   // useEffect(() => {
//   //   // Define warehouse status only when status is selected
//   //   const warehouseStatus = status ? (status.id === 0 ? 0 : 1) : null;
  
//   //   // Base URL
//   //   const url = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${cust !== null ? cust.id : 0}`;
  
//   //   // Search URL
//   //   const searchUrl = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${cust?.id}/${search}`;
//   //   // http://0.0.0.0:4444/v1/barcode/lists/:company_id/:page_size/:current_page/:outlet_id/:g_v_status/:s_us_status

//   //   const warehouseUrl = warehouseStatus !== null
//   //     ? `${url}/${warehouseStatus}`
//   //     : null;
  
//   //   // Determine which URL to fetch
//   //   const fetchUrl = search
//   //     ? searchUrl
//   //     : warehouseUrl
//   //     ? warehouseUrl
//   //     : url;
  
//   //   // Make API call only when fetchUrl is defined
//   //   if (warehouseUrl || search === '') {
//   //     axios.get(fetchUrl)
//   //       .then(res => {
//   //         console.log(res.data);
//   //         setData(res.data.data);
//   //         setPageCount(res.data.meta.pagination.total);
//   //         setSwitchData(res.data.data);
//   //       })
//   //       .catch(err => {
//   //         console.error(err);
//   //         dispatch(setSnackbar(true, 'error', err.response?.data?.errors[0]?.message || 'Error occurred'));
//   //         setData([]);
//   //       });
//   //   }
//   // }, [search, page, rowsPerPage, switchStatus, cust, status]); // Dependency on status, search, and others
//   // useEffect(() => {
//   //   // Define g_v_status and s_us_status based on selected status and sale status
//   //   const g_v_status = status ? (status.id === 0 ? 0 : status.id) : 0; // 0: All, 1: Generated, 2: Verified
//   //   const s_us_status = salesStatus ? (salesStatus === 0 ? 0 : salesStatus.id) : 0; // 0: All, 1: Un-sold, 2: Sold
  
//   //   // Define warehouseStatus only when status is selected
//   //   const warehouseStatus = status ? (status.id === 0 ? 0 : 1) : null;
  
//   //   // Base URL
//   //   const url = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${cust !== null ? cust.id : 0}/${g_v_status}/${s_us_status}?discount_min=${filters.discount_min}&discount_max=${filters.discount_max}`;
  
//   //   // Search URL
//   //   const searchUrl = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${cust?.id}/${g_v_status}/${s_us_status}/${search}`;
//   //   // const searchUrl = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${cust?.id}/${search}/${g_v_status}/${s_us_status}`;
  
//   //   // Warehouse URL
//   //   const warehouseUrl = warehouseStatus !== null
//   //     ? `${url}/${warehouseStatus}`
//   //     : null;
  
//   //   // Determine which URL to fetch
//   //   const fetchUrl = search ? searchUrl : warehouseUrl || url;
  
//   //   // Make API call only when fetchUrl is defined
//   //   if (fetchUrl) {
//   //     axios.get(fetchUrl)
//   //       .then(res => {
//   //         console.log(res.data);
//   //         setData(res.data.data);
//   //         setPageCount(res.data.meta.pagination.total);
//   //         setSwitchData(res.data.data);
//   //       })
//   //       .catch(err => {
//   //         console.error(err);
//   //         const errorMessage = err.response?.data?.errors?.[0]?.message || 'Error occurred';
//   //         dispatch(setSnackbar(true, 'error', errorMessage));
//   //         setData([]);
//   //       });
//   //   }
//   // }, [search, page, rowsPerPage, switchStatus, cust, status,salesStatus,filters]); // Dependencies
  
//   useEffect(() => {
//   // Define g_v_status and s_us_status based on selected status and sale status
//   const g_v_status = status ? (status.id === 0 ? 0 : status.id) : 0; // 0: All, 1: Generated, 2: Verified
//   const s_us_status = salesStatus ? (salesStatus === 0 ? 0 : salesStatus.id) : 0; // 0: All, 1: Un-sold, 2: Sold


//   // Define warehouseStatus only when status is selected
//   const warehouseStatus = status ? (status.id === 0 ? 0 : 1) : null;

//   // Base Path without query params
//   const basePath = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${cust !== null ? cust.id : 0}/${g_v_status}/${s_us_status}`;

//   // Warehouse Path if applicable
//   const warehousePath = warehouseStatus !== null
//     ? `${basePath}/${warehouseStatus}`
//     : basePath;

//   // Query Params for discount
//    const queryParams = `?discount_min=${filters.discount_min}&discount_max=${filters.discount_max}`;

//   // Final URLs
//   const url = `${basePath}${queryParams}`;
//   const warehouseUrl = `${warehousePath}${queryParams}`;
//   const searchUrl = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${cust?.id}/${g_v_status}/${s_us_status}/${search}`;

  
//   // Determine which URL to fetch
//   const fetchUrl = search ? searchUrl : (warehouseStatus !== null ? warehouseUrl : url);

//   // Make API call only when fetchUrl is defined
//   if (fetchUrl) {
//     axios.get(fetchUrl)
//       .then(res => {
//         console.log(res.data);
//         setData(res.data.data);
//         setPageCount(res.data.meta.pagination.total);
//         setSwitchData(res.data.data);
//       })
//       .catch(err => {
//         console.error(err);
//         const errorMessage = err.response?.data?.errors?.[0]?.message || 'Error occurred';
//         dispatch(setSnackbar(true, 'error', errorMessage));
//         setData([]);
//       });
//   }
// }, [search, page, rowsPerPage, switchStatus, cust, status, salesStatus, filters]);


//   console.log(switchStatus)
//   console.log(data)
//   console.log(checkedRows.length)
//   return (
//     <div className='w-full'>
//       <div className='text-end my-2'>
//       {checkedRows.length > 0 && 
//         <div>
//           <select id="printerDropdown" value={selectedPrinter} onChange={handlePrinterChange} style={{border:"1px solid violet",marginInlineEnd:5}}>
//             <option value="">Select Printer</option>
//             {printers.map(printer => (
//               <option key={printer} value={printer}>{printer}</option>
//             ))}
//           </select>
//           <Button variant='contained' disabled={!selectedPrinter} onClick={handleTestPrint}>Print</Button>
//         </div>
//       }
//       </div>
//       {/* <Grid >
//       <Autocomplete 
//             size="small"
//             options={[ { id: 0, fullname: "All" },{ id: -1, fullname: "WAREHOUSE" }, ...supplier]} // "All" option added
//             // options={[{id:0 , fullname : "All"} , ...supplier]}
//             disableClearable
//             value={cust}
//             onChange={(e,value)=>setCust(value)}
//             getOptionLabel={option=>option.fullname} 
//             renderInput={(params) => <TextField {...params} label="Select Outlet" />}
//             sx={{width:"300px",marginBlockStart:2}}
//           />
//       </Grid> */}
//       {/* <Grid >
//       <Autocomplete 
//             size="small"
//             options={[ { id: 0, fullname: "Generated" },{ id: -1, fullname: "Verified" },]} // "All" option added
//             // options={[{id:0 , fullname : "All"} , ...supplier]}
//             disableClearable
//             value={status}
//             onChange={(e,value)=>setStatus(value)}
//             getOptionLabel={option=>option.fullname} 
//             renderInput={(params) => <TextField {...params} label="Select Status" />}
//             sx={{width:"300px",marginBlockStart:2}}
//           />
//       </Grid> */}
// <Grid container spacing={2} sx={{ marginBlockStart: 2 }}>
//   {/* Outlet Autocomplete */}
//   <Grid item xs={12} sm={4} lg={2}>
//     <Autocomplete
//       size="small"
//       options={[{ id: 0, fullname: "All" }, { id: -1, fullname: "WAREHOUSE" }, ...supplier]} // "All" option added
//       disableClearable
//       value={cust}
//       onChange={(e, value) => setCust(value)}
//       getOptionLabel={(option) => option.fullname}
//       renderInput={(params) => <TextField {...params} label="Select Outlet" />}
//     />
//   </Grid>

//   {/* Status Autocomplete */}
//   <Grid item xs={12} sm={4} lg={2}>
//     <Autocomplete
//       size="small"
//       options={[
//         { id: 0, fullname: "All" },
//         { id: 1, fullname: "Generated" },
//         { id: 2, fullname: "Verified" },
//       ]}
//       disableClearable
//       value={status}
//       onChange={(e, value) => setStatus(value)} // Update status
//       getOptionLabel={(option) => option.fullname}
//       renderInput={(params) => <TextField {...params} label="Select Status" />}
//     />
//   </Grid>

//   {/* Sale Status Autocomplete */}
//   <Grid item xs={12} sm={4} lg={2}>
//     <Autocomplete
//       size="small"
//       options={[
//         { id: 0, fullname: "All" },
//         { id: 1, fullname: "Un Sold" },
//         { id: 2, fullname: "Sold" },
//       ]}
//       disableClearable
//       value={salesStatus}
//       onChange={(e, value) => setSalesStatus(value)} // Update sales status
//       getOptionLabel={(option) => option.fullname}
//       renderInput={(params) => <TextField {...params} label="Select Sale Status" />}
//     />
//   </Grid>
//   {/* damage/missed autocomplete */}
//   <Grid item xs={12} sm={4} lg={2}>
//   <Autocomplete
//     size="small"
//     options={[
//       { id: 0, fullname: "All" },
//       { id: 1, fullname: "Missed" },
//       { id: 2, fullname: "Damaged" }
//     ]}
//     disableClearable
//     value={missedDamageStatus}
//     onChange={(e, value) => setMissedDamageStatus(value)}
//     getOptionLabel={option => option.fullname}
//     renderInput={params => <TextField {...params} label="Missed/Damage Status" />}
//   />
// </Grid>

//   <Grid item xs={12} sm={2} lg={2} >
//   <TextField  
//     size="small"
//     type="number"
//     label="Min Disc"
//     name="discount_min"
//     value={filters.discount_min}
//     inputProps={{ min: 0, max: 100 }}
//     onChange={(e) => {
//       let value = e.target.value;
//       if (value === '') {
//         handleFilterChange(e);
//       } else if (Number(value) >= 0 && Number(value) <= 100) {
//         handleFilterChange(e);
//       }
//     }}
//   />
  
//   <TextField
//     size="small"
//     type="number"
//     label="Max Disc"
//     name="discount_max"
//      sx={{ pl: 1 }}
//     value={filters.discount_max}
//     inputProps={{ min: 0, max: 100 }}
//     onChange={(e) => {
//       let value = e.target.value;
//       if (value === '') {
//         handleFilterChange(e);
//       } else if (Number(value) >= 0 && Number(value) <= 100) {
//         handleFilterChange(e);
//       }
//     }}
//   />
// </Grid>

// </Grid>

//         <CustomDataGrid props={props}/>
//     </div>
//   )
// }

// export default memo(BarcodeTable)


import React, { memo, useEffect, useState } from 'react'
import CustomDataGrid from '../../../../../components/dataTable/customDataGrid'
import { Autocomplete, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, Switch, TextField } from '@mui/material'
import { Delete, Print, Visibility, VisibilityOff } from '@mui/icons-material'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import _ from 'lodash'
import QRCode from 'react-qr-code'

const BarcodeTable = () => {
  const dispatch = useDispatch()
  const outletID = localStorage.getItem("outlet_id")
  const roleId = localStorage.getItem("role_id")
  const [supplier, setSupplier] = useState([]);
  const [cust, setCust] = useState({ id: 0, fullname: 'All' })
  const [status, setStatus] = useState()
  const [salesStatus, setSalesStatus] = useState()
  const [missedDamageStatus, setMissedDamageStatus] = useState();
  const pageOption = [10, 25, 50, 100]
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState('')
  const [data, setData] = useState([])
  const [switchStatus, setSwitchStatus] = useState(false)
  const [switchData, setSwitchData] = useState([])
  const [checkedRows, setCheckedRows] = useState([]);
  const [printers, setPrinters] = useState([]);
  const [selectedPrinter, setSelectedPrinter] = useState('barcode');
  const [filters, setFilters] = useState({
    discount_min: '',
    discount_max: '',
  });
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletePassword, setDeletePassword] = useState('');
  const [pendingDeleteBarcode, setPendingDeleteBarcode] = useState(null);
  const [showDeletePassword, setShowDeletePassword] = useState(false);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    window.JSPM.JSPrintManager.auto_reconnect = true;
    window.JSPM.JSPrintManager.start();
    window.JSPM.JSPrintManager.WS.onStatusChanged = () => {
      if (jspmWSStatus()) {
        window.JSPM.JSPrintManager.getPrinters().then(myPrinters => {
          const updatedPrinters = [...myPrinters, 'barcode'];
          setPrinters(updatedPrinters);
        });
      }
    };
    const jspmWSStatus = () => {
      if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Open) {
        return true;
      } else if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Closed) {
        alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
        return false;
      } else if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Blocked) {
        alert('JSPM has blocked this website!');
        return false;
      }
    };
    return () => {};
  }, []);

  const handlePrinterChange = event => {
    setSelectedPrinter(event.target.value);
  };

  const handleTestPrint = () => {
    if (checkedRows.length % 4 === 0 && selectedPrinter) {
      const content = generateXPML();
      const encoder = new TextEncoder();
      const buffer = encoder.encode(content);
      const cpj = new window.JSPM.ClientPrintJob();
      cpj.clientPrinter = new window.JSPM.InstalledPrinter(selectedPrinter);
      cpj.binaryPrinterCommands = new Uint8Array(buffer);
      cpj.sendToClient();
    } else if (!selectedPrinter) {
      dispatch(setSnackbar(true, "error", "Please select Printer Type"))
    } else {
      dispatch(setSnackbar(true, "error", "Series of 4 barcode selection is allowed at a time"))
    }
  };

  const generateXPML = () => {
    let xpmlMarkup = '';
    const Data = checkedRows.map(item => ({
      barcode: item.barcode,
      itemCode: item.sub_title,
      MRP: parseFloat(item.mrp.replace("Rs.", "").trim()),
      subTitle: item.sub_title,
      itemName: item.sub_title
    }));
    let j = 0;
    for (let i = 0; i < Data.length; i++) {
      const dr = Data[i];
      if (i % 4 === 3) {
        xpmlMarkup += `
          TEXT 770,113,"3",180,1,1,"GIRLUSH"
          TEXT 790,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
          TEXT 788,61,"0",180,8,8,"Rs:"
          TEXT 750,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
          TEXT 790,32,"0",180,7,9,"${dr.barcode || ''}"
          QRCODE 670,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"
        `;
      }
      if (i % 4 === 2) {
        xpmlMarkup += `
          TEXT 571,113,"3",180,1,1,"GIRLUSH"
          TEXT 591,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
          TEXT 589,61,"0",180,8,8,"Rs:"
          TEXT 551,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
          TEXT 591,32,"0",180,7,9,"${dr.barcode || ''}"
          QRCODE 471,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"
        `;
      }
      if (i % 4 === 1) {
        xpmlMarkup += `
          TEXT 371,113,"3",180,1,1,"GIRLUSH"
          TEXT 391,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
          TEXT 389,61,"0",180,8,8,"Rs:"
          TEXT 351,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
          TEXT 391,32,"0",180,7,9,"${dr.barcode || ''}"
          QRCODE 271,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"
        `;
      }
      if (i % 4 === 0) {
        xpmlMarkup += `<xpml>
          <page quantity='0' pitch='15.0 mm'></xpml>SIZE 101.6 mm, 15 mm
          DIRECTION 0,0
          REFERENCE 0,0
          OFFSET 0 mm
          SET PEEL OFF
          SET CUTTER OFF
          SET PARTIAL_CUTTER OFF
          <xpml></page></xpml><xpml><page quantity='1' pitch='15.0 mm'></xpml>SET TEAR ON
          CLS`;

        xpmlMarkup += `
          TEXT 172,113,"3",180,1,1,"GIRLUSH"
          TEXT 192,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
          TEXT 190,61,"0",180,8,8,"Rs:"
          TEXT 152,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
          TEXT 192,32,"0",180,7,9,"${dr.barcode || ''}"
          TEXT 48,102,"0",180,6,6,"${dr.purchaseCode || ''}"
          QRCODE 72,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"  
        `; 
      }
      j++;
      if (j % 4 === 0) {
        xpmlMarkup += `
        PRINT 1,1
        <xpml></page></xpml><xpml><end/></xpml>
      `; 
      }      
    }
    return xpmlMarkup;
  };

  const onStatusChange = (e) => {
    const switchDatas = {
      barcode: e.barcode,
      is_active: e.status === true ? false : true
    }
    axios.post(`/v1/barcode/deactivate , switchDatas`)
      .then((res) => { setSwitchStatus(!switchStatus) })
      .catch((err) => { dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message)) })
  }

  const handleCheckboxChange = (row) => {
    const selectedIndex = checkedRows.findIndex(selectedRow => selectedRow.id === row.id);
    let newChecked = [];
    if (selectedIndex === -1) {
      newChecked = newChecked.concat(checkedRows, row);
    } else if (selectedIndex === 0) {
      newChecked = newChecked.concat(checkedRows.slice(1));
    } else if (selectedIndex === checkedRows.length - 1) {
      newChecked = newChecked.concat(checkedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newChecked = newChecked.concat(
        checkedRows.slice(0, selectedIndex),
        checkedRows.slice(selectedIndex + 1)
      );
    }
    setCheckedRows(newChecked);
  };

  const handlePrint = (e, selectedRow) => {
    if (checkedRows.length > 0) {
      // Print the selected rows
    } else if (selectedRow) {
      // Print the row associated with the clicked print button
    } else {
      dispatch(setSnackbar(true, 'error', "No row selected"))
    }
  }

  function getSupplierData() {
    axios
      .get(`/v1/outlet/list/1`)
      .then((res) => {
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }

  const handleDeleteRow = (rowIndex) => {
    setPendingDeleteBarcode({ barcode: data[rowIndex].barcode, rowIndex });
    setDeletePassword('');
    setShowDeletePassword(false);
    setDeleteDialogOpen(true);
  };

  const deleteTempData = () => {
    if (!deletePassword) {
      dispatch(setSnackbar(true, 'error', 'Please enter your password'));
      return;
    }
    axios.post(`/v1/barcode/list/del`, {
      barcode: [pendingDeleteBarcode.barcode],
      password: deletePassword
    })
      .then(res => {
        const updatedData = [...data];
        updatedData.splice(pendingDeleteBarcode.rowIndex, 1);
        setData(updatedData);
        setDeleteDialogOpen(false);
        setDeletePassword('');
        setPendingDeleteBarcode(null);
        dispatch(setSnackbar(true, 'success', 'Barcode deleted successfully!'));
      })
      .catch(err => {
        dispatch(setSnackbar(true, 'error', err.response?.data?.errors?.[0]?.message || 'Error deleting barcode'));
      });
  };

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <FormControlLabel control={
          <Checkbox disabled={params.row.status === false} 
            onChange={() => handleCheckboxChange(params.row)}
          />}
          label={params.row.sno} />
      )
    },
    { field: "code", headerName: "Code", flex: 1, headerAlign: "center", align: "center", sortable: false },
    { field: "fullname", headerName: "Outlet Name", flex: 1, headerAlign: "center", align: "center", sortable: false },
    { field: "product", headerName: "Product Name", flex: 1, headerAlign: "center", align: "center", sortable: false },
    { field: "barcode", headerName: "Barcode", minWidth: 170, headerAlign: "center", align: "center", sortable: false },
    { field: "barCodeImg", headerName: "QR Code", disableExport: true, flex: 1, headerAlign: "center", align: "center", sortable: false,
      renderCell: (params) => <QRCode value={params.row.barcode} style={{ height: 20, width: 20 }} />
    },
    { field: "mainCatName", headerName: "Main Category Name", minWidth: 170, headerAlign: "center", align: "center", sortable: false },
    { field: "subCatName", headerName: "Sub Category Name", minWidth: 170, headerAlign: "center", align: "center", sortable: false },
    { field: "specialDisc", headerName: "Special Discount", minWidth: 170, headerAlign: "center", align: "center", sortable: false },
    { field: "active", headerName: "Status", flex: 1, headerAlign: "center", align: "center", disableExport: true, sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div>
          <Chip size='small' color={params.row.isVerified === 1 ? 'success' : params.row.isVerified === 2 ? 'error' : "primary"} label={params.row.isVerified === 1 ? 'Verified' : params.row.isVerified === 2 ? 'Missed' : "Generated"} />
        </div>
      )
    },
    { field: "is_missed", headerName: "Missed Status", headerAlign: "center", align: "center", sortable: false, disableExport: true,
      renderCell: (params) => (
        params.row.is_missed
          ? <Chip size="small" color="warning" label="Missed" />
          : <Chip size="small" color="default" label="-" />
      )
    },
    { field: "is_damage", headerName: "Damage Status", headerAlign: "center", align: "center", sortable: false, disableExport: true,
      renderCell: (params) => (
        params.row.is_damage === 1
          ? <Chip size="small" color="error" label="Damaged" />
          : <Chip size="small" color="default" label="-" />
      )
    },
    {
  field: "purchase_return",
  headerName: "Purchase Return",
  headerAlign: "center",
  align: "center",
  sortable: false,
  disableExport: true,
  renderCell: (params) => (
    params.row.purchase_return
      ? <Chip size="small" color="primary" label="Returned" />
      : <Chip size="small" color="default" label="-" />
  )
},
    { field: "status", disableExport: true, headerName: "Status", headerAlign: "center", align: "center", sortable: false,
      renderCell: (params) => (
        <Switch
          onChange={() => onStatusChange(params.row)}
          checked={params.row.status}
        />
      )
    },
    { field: "action", headerName: "Action", headerAlign: "center", disableExport: true, align: "center", sortable: false,
      renderCell: (params) => (
        <>
          <Button onClick={() => handlePrint(params.row)} disabled={params.row.status === false}><Print color={params.row.status ? '' : 'disabled'} /></Button>
          {(roleId === '1' || roleId === '2') && (
            <IconButton
              onClick={() => {
                const rowIndex = data.findIndex(item => item.barcode === params.row.barcode);
                handleDeleteRow(rowIndex);
              }}
            >
              <Delete sx={{ color: 'red', fontSize: 18 }} />
            </IconButton>
          )}
        </>
      )
    },
  ];

  const rows = _.map(data, (val, idx) => ({
    id: val.barcode,
    sno: idx + 1,
    product: val.item_name || "-",
    barcode: val.barcode,
    status: val.is_active,
    mrp: val.mrp,
    sub_title: val.sub_title,
    title: val.title,
    code: val.code || "-",
    fullname: val.fullname || "-",
    isVerified: val.is_verified,
    mainCatName: val.main_category_name,
    subCatName: val.sub_category_name,
    specialDisc: val.special_discount,
    is_missed: val.is_missed,
    is_damage: val.is_damage,
    purchase_return: val.purchase_return,
  }));

  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch: setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  }

  useEffect(() => {
    getSupplierData();
  }, []);

  // THIS IS THE CRUCIAL UPDATED SECTION:
  useEffect(() => {
    const g_v_status = status ? (status.id === 0 ? 0 : status.id) : 0;
    const s_us_status = salesStatus ? (salesStatus === 0 ? 0 : salesStatus.id) : 0;
    let queryString = `?discount_min=${filters.discount_min}&discount_max=${filters.discount_max}`;
    if (missedDamageStatus) {
      if (missedDamageStatus.id === 1) queryString += '&is_missed=1';
      if (missedDamageStatus.id === 2) queryString += '&is_damage=1';
      if (missedDamageStatus.id === 3) queryString += '&purchase_return=true';
    }
    const basePath = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${cust !== null ? cust.id : 0}/${g_v_status}/${s_us_status}`;
    const url = `${basePath}${queryString}`;
    const searchUrl = `/v1/barcode/lists/1/${rowsPerPage}/${page + 1}/${cust?.id}/${g_v_status}/${s_us_status}/${search}${queryString}`;
    const fetchUrl = search ? searchUrl : url;
    if (fetchUrl) {
      axios.get(fetchUrl)
        .then(res => {
          setData(res.data.data);
          setPageCount(res.data.meta.pagination.total);
          setSwitchData(res.data.data);
        })
        .catch(err => {
          const errorMessage = err.response?.data?.errors?.[0]?.message || 'Error occurred';
          dispatch(setSnackbar(true, 'error', errorMessage));
          setData([]);
        });
    }
  }, [search, page, rowsPerPage, switchStatus, cust, status, salesStatus, missedDamageStatus, filters]);

  return (
    <div className='w-full'>
      <div className='text-end my-2'>
        {checkedRows.length > 0 &&
          <div>
            <select id="printerDropdown" value={selectedPrinter} onChange={handlePrinterChange} style={{ border: "1px solid violet", marginInlineEnd: 5 }}>
              <option value="">Select Printer</option>
              {printers.map(printer => (
                <option key={printer} value={printer}>{printer}</option>
              ))}
            </select>
            <Button variant='contained' disabled={!selectedPrinter} onClick={handleTestPrint}>Print</Button>
          </div>
        }
      </div>
      <Grid container spacing={2} sx={{ marginBlockStart: 2 }}>
        <Grid item xs={12} sm={4} lg={2}>
          <Autocomplete
            size="small"
            options={[{ id: 0, fullname: "All" }, { id: -1, fullname: "WAREHOUSE" }, ...supplier]}
            disableClearable
            value={cust}
            onChange={(e, value) => setCust(value)}
            getOptionLabel={(option) => option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet" />}
          />
        </Grid>
        <Grid item xs={12} sm={4} lg={2}>
          <Autocomplete
            size="small"
            options={[
              { id: 0, fullname: "All" },
              { id: 1, fullname: "Generated" },
              { id: 2, fullname: "Verified" },
            ]}
            disableClearable
            value={status}
            onChange={(e, value) => setStatus(value)}
            getOptionLabel={(option) => option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Status" />}
          />
        </Grid>
        <Grid item xs={12} sm={4} lg={2}>
          <Autocomplete
            size="small"
            options={[
              { id: 0, fullname: "All" },
              { id: 1, fullname: "Un Sold" },
              { id: 2, fullname: "Sold" },
            ]}
            disableClearable
            value={salesStatus}
            onChange={(e, value) => setSalesStatus(value)}
            getOptionLabel={(option) => option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Sale Status" />}
          />
        </Grid>
        <Grid item xs={12} sm={4} lg={2}>
          <Autocomplete
            size="small"
            options={[
              { id: 0, fullname: "All" },
              { id: 1, fullname: "Missed" },
              { id: 2, fullname: "Damaged" },
              { id: 3, fullname: "Purchase Return" }
            ]}
            disableClearable
            value={missedDamageStatus}
            onChange={(e, value) => setMissedDamageStatus(value)}
            getOptionLabel={option => option.fullname}
            renderInput={params => <TextField {...params} label="Missed/Damage Status" />}
          />
        </Grid>
        <Grid item xs={12} sm={2} lg={2}>
          <TextField
            size="small"
            type="number"
            label="Min Disc"
            name="discount_min"
            value={filters.discount_min}
            inputProps={{ min: 0, max: 100 }}
            onChange={(e) => {
              let value = e.target.value;
              if (value === '') {
                handleFilterChange(e);
              } else if (Number(value) >= 0 && Number(value) <= 100) {
                handleFilterChange(e);
              }
            }}
          />
          <TextField
            size="small"
            type="number"
            label="Max Disc"
            name="discount_max"
            sx={{ pl: 1 }}
            value={filters.discount_max}
            inputProps={{ min: 0, max: 100 }}
            onChange={(e) => {
              let value = e.target.value;
              if (value === '') {
                handleFilterChange(e);
              } else if (Number(value) >= 0 && Number(value) <= 100) {
                handleFilterChange(e);
              }
            }}
          />
        </Grid>
      </Grid>
      <CustomDataGrid props={props} />

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p style={{ marginBottom: 12, color: '#555' }}>
            Enter your password to delete barcode <strong>{pendingDeleteBarcode?.barcode}</strong>
          </p>
          <TextField
            autoFocus
            fullWidth
            size="small"
            type={showDeletePassword ? 'text' : 'password'}
            label="Your Password"
            value={deletePassword}
            onChange={(e) => setDeletePassword(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && deleteTempData()}
            InputProps={{
              endAdornment: (
                <IconButton size="small" onClick={() => setShowDeletePassword(prev => !prev)} edge="end">
                  {showDeletePassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                </IconButton>
              )
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" color="error" onClick={deleteTempData}>Delete</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default memo(BarcodeTable)